/**
 * RefType danh mục
 */
export default {
  CustomerVendor: 1, // Khách hàng, nhà cung cấp
  Employee: 2, // Cán bộ
  EmployeeType: 3, // Loại cán bộ
};
